<template>
  <div>
    <b-navbar sticky="true" type="light" variant="light">
		<div class="container">
			<b-navbar-brand to="/god-is-dead">上帝已死</b-navbar-brand>
			<b-navbar-nav class="ml-auto" small="true" >
				<!-- <b-nav-item to="#">概览</b-nav-item>
      			<b-nav-item to="#">如何使用</b-nav-item> -->
				<b-button rel="noopener" target="_blank" pill size="sm" variant="primary" @click="leaveFor" href="battlenet:://starcraft/map/5/63436" >前往战网游玩</b-button>
			</b-navbar-nav>
		</div>
    </b-navbar>

	<div class="card-container" >
      <div class="card-content" >
		  <div class="description-container" style="text-align: center;" >
              <div>
                <h1>上帝已死</h1>
                <h3>我们美术设计最好的地图</h3>
                <p>一处研究设施一夜之间毫无音讯，你们被总部派往前去调查。到达目的地之后，发现这里并没有人占领，或者说，根本没有人类活动的迹象。你们按照事先的计划进行调查，但在调查中发现不明生物。危急时刻向总部发出求救信号，但是他们却只关心任务是否完成，你满是怨言，但其实早已习惯。只好硬着头皮完成任务...哦....不，活下去都是个问题。			
                </p>
                <PartnerAuthor></PartnerAuthor>
              </div>
            </div>
			<div class="img-container" >
				<img src="@/assets/SC_Map/God_is_Dead/control_panel.jpg" >
			</div>
	  </div>
    </div>

	<div class="card-container" >
      <div class="card-content" >
        <b-row no-gutters>
          <b-col sm="6">
            
            <div class="img-container" >
              <img src="@/assets/SC_Map/God_is_Dead/origin_area.jpg" >
            </div>
                
          </b-col>
          <b-col sm="6">
            
            <div class="description-container">
              <div>
                <h2>谜样生物</h2>
				<h3>创造敌人是一种怎样的体验</h3>
				<p>首先，准备好一支精英小队。
				其次，与你的队友携手前行。
				最后，你将被自己亲手带领的小队消灭。
				</p>
              </div>
            </div>
            
          </b-col>
        </b-row>
      </div>
    </div>

  </div>
</template>

<style lang="stylus" scoped>
	@import '~@/components/OverviewCard.styl'
</style>

<script>
import PartnerAuthor from '@/components/PartnerAuthor'
export default {
    methods: {
        leaveFor() {
            this.$ga.event('sc-map', 'battlenet', 'god-is-dead', 1)
            },
	},
  name: 'about',
    components: {
        PartnerAuthor
  }
}
</script>